import React from 'react';
import PropTypes from 'prop-types';
import { faCircleQuestion, faUpload } from '@fortawesome/pro-solid-svg-icons';
import { faEye, faPlus, faMinus, faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from 'react-bootstrap';
import DropDown from '../../../../components/DropDown';
import Modal from '../../../../components/Modal';
import {
  useGetResourceDocMutation,
  useUpdateAssignmentLessonMutation,
  useGetHtmlContentMutation,
} from '../../../../features/authentication/assignmentApislice';
import {
  useGetDocumentsBySetIdMutation,
  useCreateTeacherDocumentMutation
} from '../../../../features/authentication/teacherDocumentApiSlice';
import {
  useGetTeacherDocumentsMutation,
  useGetPublicDocumentsMutation,
  useAddDocumentsMutation
} from '../../../../features/authentication/assignmentDocumentApiSlice';
import {
  useGetResourceSetsMutation,
  useCreateResourceSetMutation
} from '../../../../features/authentication/qSetApiSlice';
import {
  useGetLessonSetsMutation
} from '../../../../features/authentication/setApiSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomToast from '../../../../components/Toast';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import appConfig from '../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../features/authentication/authSlice';
import { ResourceUtils } from './ResourceUtils';
import VideoModal from './VideoModal';
import DocumentModal from './DocumentModal';
import AudioModal from './AudioModal';
import LessonModal from './LessonModal';
import ResourceList from './ResourceList';
import ConfirmationModal from '../../../../components/ConfirmationPopUp';
import Skeleton from 'react-loading-skeleton';
import ActivityTypes from '../../../../enums/activityTypes';

const baseUrl = appConfig.apiBaseUrl;

const AddNewResource = (props) => {
  const [documentText, setDocumentText] = React.useState('');
  const [videoModal, setVideoModal] = React.useState(false);
  const [videoUrl, setVideoUrl] = React.useState('');
  const [audioUrl, setAudioUrl] = React.useState('');
  const [documentModal, setDocumentModal] = React.useState(false);
  const [audioModal, setAudioModal] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(0);
  const [getResourceDoc] = useGetResourceDocMutation();
  const [getPublicDocuments] = useGetPublicDocumentsMutation();
  const [documentId, setDocumentId] = React.useState(null);
  const [publicDocuments, setPublicDocuments] = React.useState([]);
  const [getTeacherDocuments] = useGetTeacherDocumentsMutation();
  const [teacherDocuments, setTeacherDocuments] = React.useState([]);
  const [addDocuments] = useAddDocumentsMutation();
  const [openAddDocument, setOpenAddDocument] = React.useState(false);
  const [isDocsLoading, setIsDocsLoading] = React.useState(true);
  const [openAddNewResource, setOpenAddNewResource] = React.useState(false);
  const [isExistingResource, setIsExisitingResource] = React.useState(true);
  const [getResourceSets] = useGetResourceSetsMutation();
  const [allResourceSets, setAllResourceSets] = React.useState([]);
  const [selectedResourceSetId, setSelectedResourceSetId] = React.useState('');
  const [createResourceSet] = useCreateResourceSetMutation();
  const [description, setDescription] = React.useState('');
  const [getDocumentsBySetId] = useGetDocumentsBySetIdMutation();
  const [documents, setDocuments] = React.useState(null);
  const [isLoadingDocuments, setIsLoadingDocuments] = React.useState(true);
  const [selectedResourceId, setSelectedResourceId] = React.useState(null);
  const [selectedResourceSetName, setSelectedResourceSetName] = React.useState('');
  const [isUpdateDescription, setIsUpdateDescription] = React.useState(false);
  const [openAddResource, setOpenAddResource] = React.useState(false);
  const [selectedResourceType, setSelectedResourceType] = React.useState(null);
  const [createTeacherDocument] = useCreateTeacherDocumentMutation();
  const [url, setUrl] = React.useState('');
  const [files, setFiles] = React.useState(null);
  const [searchKeyword, setSearchKeyword] = React.useState('');
  const [originalDocuments, setOriginalDocuments] = React.useState(null);
  const token = useSelector(selectCurrentToken);
  const [resourceSetName, setResourceSetName] = React.useState('');
  const [isWaiting, setIsWaiting] = React.useState(false);
  const [displayText, setDisplayText] = React.useState('');
  const [openAttachConfirmModal, setOpenAttachConfirmModal] = React.useState(false);
  const [openDetachConfirmModal, setOpenDetachConfirmModal] = React.useState(false);
  const [updateAssignmentLesson] = useUpdateAssignmentLessonMutation();
  const [lessonId, setLessonId] = React.useState(null);
  const [sortId, setSortId] = React.useState('');
  const [isAscending, setIsAscending] = React.useState(true);
  const [lessonModal, setLessonModal] = React.useState(false);
  const [lessonText, setLessonText] = React.useState('');
  const [lessonDescription, setLessonDescription] = React.useState('');
  const [getHtmlContent] = useGetHtmlContentMutation();
  const [getLessonSets] = useGetLessonSetsMutation();
  const [lessons, setLessons] = React.useState(null);

  const resourceViewHandler = async (resourceType, resourceId, resourceUrl) => {
    setDocumentText('');
    let link;
    switch (resourceType) {
    case 'Video':
      setVideoModal(true);
      setVideoUrl(resourceUrl);
      break;
    case 'Document':
      try {
        const option = { documentId: resourceId };
        setDocumentModal(true);
        const response = await getResourceDoc(option).unwrap();
        setDocumentText(response.resourceText);
      } catch (error) {
        console.error(error);
      }
      break;
    case 'Audio':
      setAudioModal(true);
      setAudioUrl(resourceUrl);
      break;
    case 'Link':
    case 'PDF':
    case 'MS Word':
    case 'Power Point':
      link = document.createElement('a');
      link.href = resourceUrl;
      link.target = '_blank';
      link.click();
      break;
    case 'Lesson':
      await htmlContentHandler(resourceUrl);
      setLessonModal(true);
      break;
    default:
      console.warn('Unknown resource type: ', resourceType);
    }
  };

  const viewAndAddActionButton = (index, item, isPublic, isLesson) => {
    return <div className={`d-flex ${isPublic && 'justify-content-center'}`}>
      <OverlayTrigger
        key={`viewToolTip${index}`}
        placement="top"
        overlay={<Tooltip className="custom-tooltip">View</Tooltip>}>
        <button
          id={'view' + index}
          className="action-btn-tile yellow"
          onClick={() => { setLessonDescription(item.description); resourceViewHandler(isLesson ? 'Lesson' : item.type, isLesson ? item.setId : item.documentId, isLesson ? item.path : item.url); }}
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      </OverlayTrigger>
      {isLesson && (props.assignmentDetails?.lessonId == 0 || item.setId != props.assignmentDetails?.lessonId) ?
        <OverlayTrigger
          key={`addToolTip${index}`}
          placement="top"
          overlay={<Tooltip className="custom-tooltip">Attach</Tooltip>}>
          <button
            id={'addLesson' + index}
            className={`action-btn-tile green ${(props.assignmentDetails?.lessonId != 0) && 'disable-Pointer-Events disabled'}`}
            onClick={async () => {
              await setDisplayText(item.description);
              await setLessonId(item.setId);
              setOpenAttachConfirmModal(true);
            }}>
            <FontAwesomeIcon icon={faPlus} />
          </button>
        </OverlayTrigger>
        :
        isLesson && props.assignmentDetails?.lessonId != 0 && item.setId == props.assignmentDetails?.lessonId ?
          <OverlayTrigger
            key={`removeToolTip${index}`}
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Detach</Tooltip>}>
            <button
              id={'removeLesson' + index}
              className='action-btn-tile red'
              onClick={async () => {
                await setDisplayText(item.description);
                await setLessonId(0);
                setOpenDetachConfirmModal(true);
              }}>
              <FontAwesomeIcon icon={faMinus} />
            </button>
          </OverlayTrigger>
          :
          <OverlayTrigger
            key={`addToolTip${index}`}
            placement="top"
            overlay={<Tooltip className="custom-tooltip">Attach</Tooltip>}>
            <button
              id={'addDocument' + index}
              className="action-btn-tile green"
              onClick={async () => {
                setOpenAddDocument(true);
                props.setDisplayText(item.description.substring(0, 100));
                setDocumentId(item.documentId);
              }}>
              <FontAwesomeIcon icon={faPlus} />
            </button>
          </OverlayTrigger>
      }
    </div>;
  };

  const handlePublicDocuments = async () => {
    const response = await getPublicDocuments().unwrap();
    const modifiedResponse = ResourceUtils.addTypeToDocuments(response);
    setPublicDocuments(modifiedResponse);
    setIsDocsLoading(false);
  };

  const handleTeacherDocuments = async () => {
    const response = await getTeacherDocuments().unwrap();
    const modifiedResponse = ResourceUtils.addTypeToDocuments(response);
    setTeacherDocuments(modifiedResponse);
    setIsDocsLoading(false);
  };

  React.useEffect(() => {
    if (props.openAttachResource) {
      switch (activeTab) {
      case 0:
        handleTeacherDocuments();
        setPublicDocuments([]);
        setLessons([]);
        setSortId('owner');
        break;
      case 1:
        handlePublicDocuments();
        setTeacherDocuments([]);
        setLessons([]);
        setSortId('description');
        break;
      case 2:
        getLessons();
        setTeacherDocuments([]);
        setPublicDocuments([]);
        setSortId('label');
        break;
      }
      setIsAscending(true);
    }
  }, [props.openAttachResource, activeTab]);

  const handleAddDocuments = async () => {
    const isDisplayTextValidate = props.validateDisplayText();
    if (isDisplayTextValidate) {
      try {
        const options = {
          assignmentId: props.assignmentId,
          documentId: documentId,
          label: props.displayText
        };
        const result = await addDocuments(options);
        if (result.error) {
          CustomToast(result.error.data.error, 'error');
        }
        else {
          CustomToast('New Resource Added Successfully', 'success');
          props.setOpenAttachResource(false);
          props.setDisplayText('');
          props.castleResourceDetailsHandler(props.questionDetails?.questionId);
        }
        setOpenAddDocument(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleResourceSets = async () => {
    try {
      const result = await getResourceSets();
      if (result.error) {
        CustomToast(result.error.data.error, 'error');
      }
      else {
        const resourceArray = [];
        result.data.map((item) => {
          const obj = {
            id: item.qSetId,
            name: item.description
          };
          resourceArray.push(obj);
        });
        const objData = {
          id: -1,
          name: 'Select a Resource Set'
        };
        const resourceArrayResponse = [objData, ...resourceArray];
        setAllResourceSets(resourceArrayResponse);
        setSelectedResourceSetId(resourceArrayResponse[0].id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreateDocument = async () => {
    setIsWaiting(true);
    const option = {
      description: resourceSetName,
      activityType: ActivityTypes.Documents
    };

    try {
      const result = await createResourceSet(option);
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('New Resource Set Created', 'success');
        await getResourcesFromSetId(result.data);
        setSelectedResourceSetId(result.data);
        setSelectedResourceSetName(resourceSetName);
      }
    } catch (error) {
      console.log(error);
    }
    setIsWaiting(false);
  };

  const handleDropDownChange = async (setId) => {
    if (setId != -1 || setId == '') {
      await getResourcesFromSetId(setId);
    }
  };

  const getResourcesFromSetId = async (setId) => {
    const option = {
      setId: setId,
    };

    try {
      const result = await getDocumentsBySetId(option);
      if (result.error) {
        CustomToast(result.error.data.error, 'error');
      }
      else {
        const modifiedResponse = ResourceUtils.addTypeToDocuments(result.data.documents);
        setDocuments(modifiedResponse);
        setOriginalDocuments(modifiedResponse);
        setIsUpdateDescription(false);
        setIsLoadingDocuments(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddResource = async (isUrl) => {
    if (selectedResourceType == 'url' && !(url.startsWith('http://') || url.startsWith('https://'))) {
      CustomToast('Invalid Url Address!', 'warning');
      return;
    }
    setIsWaiting(true);
    try {
      const result = await createTeacherDocument({
        description: description,
        isURL: isUrl,
        url: url,
        scope: 0,
        setId: selectedResourceSetId
      });
      if (result.error) {
        if (result.error.data.errors)
          CustomToast(result.error.data.errors.Url || result.error.data.errors.Description, 'error');
        else
          CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Resource Created Successfully.', 'success');
        const objData = {
          documentId: result.data,
          description: description,
          isPublic: false,
          document: '',
          isAttached: false,
          isEditable: true,
          isURL: isUrl,
          url: url,
          type: selectedResourceType == 'document' ? 'Document' : 'Link'
        };
        const updatedDocumentList = [...documents, objData];
        setDocuments(updatedDocumentList);
        setOpenAddResource(false);
        setDescription('');
        setUrl('');
      }
    } catch (error) {
      console.log(error);
    }
    setIsWaiting(false);
  };

  const handleFileUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    console.log('File selected:', file);
    setFiles(file);
  };

  let request = (obj) => {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      xhr.open(obj.method || 'POST', obj.url);
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr);
        } else {
          reject(xhr.statusText);
          let response = JSON.parse(xhr.responseText);
          if (response.errors != undefined)
            CustomToast(response.errors.Description, 'error');
          else
            CustomToast(response.error, 'error');
        }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send(obj.body);
    });
  };

  const handleDocumentUpload = async () => {
    setIsWaiting(true);
    let formData = new FormData();
    formData.append('file', files);
    formData.append('setId', parseInt(selectedResourceSetId));
    formData.append('description', description);

    try {
      request({
        url: `${baseUrl}/TeacherDocument/upload`,
        method: 'POST',
        body: formData
      }).then((data) => {
        if (data.status === 200) {
          const dataObj = JSON.parse(data.responseText);
          CustomToast('Resource Uploaded Successfully', 'success');

          const objData = {
            documentId: dataObj.documentId,
            description: description,
            isPublic: false,
            document: '',
            isAttached: false,
            isEditable: false,
            isURL: true,
            url: dataObj.url
          };
          let updatedDocumentList = [...documents, objData];
          updatedDocumentList = ResourceUtils.addTypeToDocuments(updatedDocumentList);
          setDocuments(updatedDocumentList);
          setOpenAddResource(false);
          setDescription('');
          setFiles(null);
        } else {
          CustomToast('Error! Failed to Upload Resource', 'error');
        }
      });
    } catch (error) {
      console.log(error);
    }
    setIsWaiting(false);
  };

  const handleUpdateAssignmentLesson = async () => {
    const option = {
      assignmentId: props.assignmentId,
      lessonId: lessonId
    };
    await updateAssignmentLesson(option).unwrap();
    let updatedAssignmentDetails = { ...props.assignmentDetails, lessonId: lessonId };
    props.setAssignmentDetails(updatedAssignmentDetails);
    props.setLessonInfo([]);
    if (lessonId == 0)
      CustomToast('Lesson Deleted Successfully', 'success');
    else
      CustomToast('Lesson Added Successfully', 'success');
  };

  const handleSort = async (currentSortId) => {
    let sortAsc = true;
    if (currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);
    if (activeTab == 0) {
      let sortedTeacherDocs = await ResourceUtils.customSort(teacherDocuments, currentSortId, sortAsc);
      setTeacherDocuments(sortedTeacherDocs);
    }
    else if (activeTab == 1) {
      let sortedPublicDocs = await ResourceUtils.customSort(publicDocuments, currentSortId, sortAsc);
      setPublicDocuments(sortedPublicDocs);
    }
    else {
      let sortedLessons = await ResourceUtils.customSort(lessons, currentSortId, sortAsc);
      setLessons(sortedLessons);
    }
    setIsAscending(sortAsc);
  };

  const htmlContentHandler = async (path) => {
    const options = { filePath: path };
    const result = await getHtmlContent(options);
    if(result.error)
      setLessonText(result.error.data.error);
    else
    {
      setLessonText(result.data.content);
    }
    (result.error.data);
  };

  const sortButtons = (currentSortId) => {
    return <button className="assignment-sort-btn sort-btn row p-1 m-2">
      <FontAwesomeIcon icon={faCaretUp} className={`${sortId === currentSortId && isAscending ? 'enabled-caret' : ''}`} />
      <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === currentSortId && !isAscending ? 'enabled-caret' : ''}`} />
    </button>;
  };

  const getLessons = async () => {
    const option = { courseId: props.assignmentDetails?.courseId };
    const response = await getLessonSets(option).unwrap();
    setLessons(response);
    setIsDocsLoading(false);
  };

  return (
    <>
      <VideoModal videoUrl={videoUrl} isOpen={videoModal} onClose={() => setVideoModal(false)} />
      <DocumentModal value={documentText} isOpen={documentModal} onClose={() => setDocumentModal(false)} />
      <AudioModal audioUrl={audioUrl} isOpen={audioModal} onClose={() => setAudioModal(false)} />
      <LessonModal description={lessonDescription} value={lessonText} isOpen={lessonModal} onClose={() => setLessonModal(false)} />
      <Modal
        isOpen={props.openAttachResource}
        onClose={() => props.setOpenAttachResource(false)}
        titleName={'Attach Resource: ' + props.assignmentName}
        contentWidth='800px'
        detailHeight='400px'>
        <div className="d-flex flex-column pb-4">
          <div className='cursor-none'>
            Click
            <button
              id={'plusBtn'}
              className="action-btn-tile green">
              <FontAwesomeIcon icon={faPlus} />
            </button>
            icon below to attach the selected resource into your assignment.
          </div>
          <div className='d-flex justify-content-between'>
            <div className="d-inline-flex my-4 assignStudentsTabs w-fitcontent">
              <div className={`btn ${activeTab == 0 ? 'active' : ''} p-2 align-content-center`} onClick={() => { setIsDocsLoading(true); setSortId('owner'); setActiveTab(0); }}>
                Your Resources
              </div>
              <div className={`btn ${activeTab == 1 ? 'active' : ''} p-2 align-content-center`} onClick={() => { setIsDocsLoading(true); setSortId('description'); setActiveTab(1); }}>
                Public Resources
              </div>
              {props.isLessonAvailable &&
                <div className={`btn ${activeTab == 2 ? 'active' : ''} p-2 align-content-center btn-width justify-content-center`} onClick={() => { setIsDocsLoading(true); setSortId('label'); setActiveTab(2); }}>
                  Lessons
                </div>}
            </div>
            <div>
              <button id="addNewResBtn" className="btn btn-castleWhite mt-4" onClick={async () => { await handleResourceSets(); setOpenAddNewResource(true); setIsExisitingResource(true); props.setOpenAttachResource(false); }}>
                Add New Resource
              </button>
            </div>
          </div>
          <div className="custom-table table-responsive currentlist-table not-assigned-table mt-3">
            <table className="table currentlist-table z-index10 position-relative">
              <thead>
                <tr>
                  {activeTab == 0 && <th id='owner' className='cursor-pointer' onClick={(e) => handleSort(e.currentTarget.id)}>
                    Resource Set
                    {sortButtons('owner')}
                  </th>}
                  {(activeTab == 0 || activeTab == 1) && <th id='description' className='cursor-pointer' onClick={(e) => handleSort(e.currentTarget.id)}>
                    Resource Name
                    {sortButtons('description')}
                  </th>}
                  {activeTab == 0 && <th id='type' className='cursor-pointer' onClick={(e) => handleSort(e.currentTarget.id)}>
                    Resource Type
                    {sortButtons('type')}
                  </th>}
                  {activeTab == 1 && <th id='owner' className='cursor-pointer' onClick={(e) => handleSort(e.currentTarget.id)}>
                    Owner
                    {sortButtons('owner')}
                  </th>}
                  {activeTab == 2 && <th id='label' className='cursor-pointer' onClick={(e) => handleSort(e.currentTarget.id)}>
                    Lesson
                    {sortButtons('label')}
                  </th>}
                  {activeTab == 2 && <th id='description' className='cursor-pointer' onClick={(e) => handleSort(e.currentTarget.id)}>
                    Description
                    {sortButtons('description')}
                  </th>}
                  <th>{' '}</th>
                </tr>
              </thead>
              <tbody>
                {(!isDocsLoading) ?
                  <>
                    {activeTab == 0 && teacherDocuments.map((item, index) => (
                      <tr key={`teacherDoc${index}`}>
                        <td className='w-20 cursor-none'>{item.owner}</td>
                        <td className='w-min-max-250 text-truncate cursor-none'>{item.description}</td>
                        <td className='cursor-none'>{item.type}</td>
                        <td>{viewAndAddActionButton(index, item, false, false)}</td>
                      </tr>
                    ))}
                    {activeTab == 1 && publicDocuments.map((item, index) => (
                      <tr key={`publicDoc${index}`}>
                        <td className='w-60 text-truncate w-min-max-250 cursor-none'>{item.description}</td>
                        <td className='cursor-none'>{item.owner}</td>
                        <td>{viewAndAddActionButton(index, item, true, false)}</td>
                      </tr>
                    ))}
                    {activeTab == 2 && lessons.map((item, index) => (
                      <tr key={`lessons${index}`}>
                        <td className='w-15 cursor-none'>{item.label}</td>
                        <td className='w-min-max-350 text-truncate cursor-none' dangerouslySetInnerHTML={{
                          __html: item.description
                        }}></td>
                        <td>{viewAndAddActionButton(index, item, false, true)}</td>
                      </tr>
                    ))}
                  </>
                  :
                  <>
                    {Array.from({ length: 8 }).map((_, index) => (
                      <tr key={`row${index}`}>
                        {[...Array(activeTab === 0 ? 4 : 3)].map((_, index) => (
                          <td key={`th${index}`}><Skeleton /></td>
                        ))}
                      </tr>
                    ))}
                  </>
                }
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={openAddDocument}
        onClose={() => setOpenAddDocument(false)}
        titleName={'Attach Document To Assignment'}
        contentWidth='800px'>
        <div className="d-flex flex-column">
          <div className='cursor-none'>
            This is the text that will display for the student as a link to the resource in the assignment. You can edit the text or leave it as the default value.
          </div>
          <input
            type="text"
            value={props.displayText}
            onChange={(e) => props.setDisplayText(e.target.value)}
            className={`form-control mt-3 cursor-auto pt-2 ${props.displayText.length > 100 && 'border-danger'}`}
          />
          {props.displayText.length > 100 &&
            <div className="text-danger row mx-0">The Display Text has exceeded a limit of 100 characters!</div>
          }
          <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
            <button className={`btn btn-castleRed btn-width ${(props.displayText.length > 100) && 'disabled'}`} onClick={() => handleAddDocuments()}>
              Save
            </button>
            <button className="btn btn-castleGray btn-width" onClick={() => setOpenAddDocument(false)}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={openAddNewResource}
        onClose={() => { setOpenAddNewResource(false); props.setOpenAttachResource(true); setIsLoadingDocuments(true); setIsUpdateDescription(false); setSelectedResourceId(''); setSearchKeyword(''); setDocuments(null); setSelectedResourceSetName(''); }}
        titleName={'Select or Create a Resource Set'}
        contentWidth={'900px'}>
        <div className={`d-flex flex-column pb-3 ${documents?.length > 0 && selectedResourceSetId != -1 && selectedResourceSetId != '' && 'h-700'}`}>
          <div className="fs-5 d-flex gap-4 me-3 pb-2">
            <div className='gap-2 d-flex'>
              <input
                type="radio"
                className="form-check-input cursor-pointer"
                defaultChecked={true}
                id="existResourceRadio"
                name="resourceSet"
                onChange={async () => { await setDescription(''); await setSelectedResourceSetId(''); setIsExisitingResource(true); handleResourceSets(); }}
              />
              <label className="form-check-label">
                {' Add to Existing Resource Set'}
              </label>
            </div>
            <div className='gap-2 d-flex'>
              <input
                type="radio"
                className="form-check-input cursor-pointer"
                id="createResourceRadio"
                name="resourceSet"
                onChange={async () => { await setDescription(''); await setSelectedResourceSetId(''); setIsExisitingResource(false); setDocuments(null); }}
              />
              <label className="form-check-label">
                {' Create a new Resource Set'}
              </label>
            </div>
          </div>
          <div className='pt-3'>
            {isExistingResource ?
              <>
                <DropDown
                  label="Set Name"
                  value={allResourceSets}
                  onChangeHandler={(e) => {
                    setSelectedResourceSetId(parseInt(e.target.value));
                    setIsLoadingDocuments(true);
                    handleDropDownChange(parseInt(e.target.value));
                    setSearchKeyword('');
                  }}
                  selectedValue={selectedResourceSetId}
                />
              </>
              :
              <>
                <div className='pb-2'>Set Name</div>
                <div>
                  <input
                    className={`form-control content-print ${resourceSetName.length > 100 && 'border-danger'}`}
                    value={resourceSetName}
                    onChange={(e) => setResourceSetName(e.target.value)}
                  />
                  {resourceSetName.length > 100 &&
                    <div className="text-danger">Description has exceeded a limit of 100 characters!</div>
                  }
                </div>
                <div className="d-flex justify-content-end mt-4 gap-3 align-items-center">
                  <button className={`btn btn-castleRed btn-width ${((resourceSetName.length == 0 && !isExistingResource) || resourceSetName.length > 100 || isWaiting) && 'disabled'}`} onClick={() => { handleCreateDocument(); setResourceSetName(''); }}>
                    Create
                  </button>
                  <button className="btn btn-castleGray btn-width" onClick={() => { setOpenAddNewResource(false); props.setOpenAttachResource(true); setIsLoadingDocuments(true); setSearchKeyword(''); setDocuments(null); setSelectedResourceSetName(''); }}>
                    Cancel
                  </button>
                </div>
              </>
            }
            {selectedResourceSetId != -1 && selectedResourceSetId != '' &&
              <div>
                <h4 className='mb-0 pt-4 cursor-none'>{isExistingResource ? allResourceSets?.find(resourceSet => resourceSet.id == selectedResourceSetId)?.name : selectedResourceSetName} Resources</h4>
                <div className='pb-4 pt-3 gap-1 d-flex justify-content-between'>
                  <div>
                    <span className='cursor-none'>Instructions&ensp;</span>
                    <OverlayTrigger
                      key={'attached-resource-info'}
                      placement="top"
                      overlay={
                        <Tooltip className="initial-assignment-tooltip">
                          <b>Add Document : </b>
                          Use our online editor to create a custom document
                          <br></br>
                          <b>Add URL : </b>
                          Add a URL that the students can click on to go to a web page
                          <br></br>
                          <b>Upload File : </b>
                          Upload a Word, PowerPoint, PDF, MP3 or MP4 file
                          <br></br>
                          <br></br>
                          When a document is made public it will be available on the <b>Public Documents</b> tab for all teachers when adding documents to assignments and assessments.
                        </Tooltip>
                      }>
                      <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
                    </OverlayTrigger>
                  </div>
                  <div className='d-flex justify-content-end mt-3 gap-3'>
                    <button className='btn btn-castleWhite' onClick={() => { setDescription(''); setSelectedResourceType('document'); setOpenAddResource(true); setIsWaiting(false); }}>
                      Add Document
                    </button>
                    <button className='btn btn-castleWhite btn-width' onClick={() => { setDescription(''); setSelectedResourceType('url'); setOpenAddResource(true); setIsWaiting(false); }}>
                      Add Url
                    </button>
                    <button className='btn btn-castleWhite btn-width' onClick={() => { setDescription(''); setSelectedResourceType('file'); setOpenAddResource(true); setIsWaiting(false); }}>
                      Upload File
                    </button>
                  </div>
                </div>
                <ResourceList
                  originalDocuments={originalDocuments}
                  documents={documents}
                  setDocuments={setDocuments}
                  displayText={props.displayText}
                  setDisplayText={props.setDisplayText}
                  selectedResourceSetId={selectedResourceSetId}
                  isLoadingDocuments={isLoadingDocuments}
                  isUpdateDescription={isUpdateDescription}
                  setIsUpdateDescription={setIsUpdateDescription}
                  searchKeyword={searchKeyword}
                  setSearchKeyword={setSearchKeyword}
                  selectedResourceId={selectedResourceId}
                  setSelectedResourceId={setSelectedResourceId}
                ></ResourceList>
              </div>
            }
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={openAddResource}
        onClose={() => { setOpenAddResource(false); setDescription(''); setUrl(''); setFiles(null); }}
        titleName={`${selectedResourceType == 'document' ? 'Add Document' : selectedResourceType == 'url' ? 'Add URL' : selectedResourceType == 'file' ? 'Upload File' : ''}`}
        contentWidth='800px'>
        <div className="d-flex flex-column pb-4">
          <div className='pb-4'>Description
            <input
              className={`form-control content-print pt-2 ${description.length > 100 && 'border-danger'}`}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            {description.length > 100 &&
              <div className="text-danger">Description has exceeded a limit of 100 characters!</div>
            }
          </div>
          {selectedResourceType == 'url' &&
            <div className='pb-4'>{'URL (must start with http:// or https://)'}
              <input
                className={`form-control content-print pt-2 ${url.length > 255 && 'border-danger'}`}
                value={url}
                onChange={(e) => setUrl(e.target.value)}
              />
              {url.length > 255 &&
                <div className="text-danger">Url has exceeded a limit of 255 characters!</div>
              }
            </div>
          }
          {selectedResourceType == 'file' &&
            <div className='pb-4'>File&ensp;
              <OverlayTrigger
                key={'file-upload-info'}
                placement="right"
                overlay={
                  <Tooltip className="initial-assignment-tooltip">
                    Select a PDF, PowerPoint, Word, MP3 or MP4 file that is less than 500 megabytes in size.
                  </Tooltip>
                }>
                <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
              </OverlayTrigger>
              <div className="upload_xml pt-2">
                <div className="row mb-3">
                  <div className="col-12">
                    <div
                      className="custom-upload position-relative d-flex flex-column justify-content-center align-items-center p-5 text-center"
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        e.dataTransfer.dropEffect = 'copy';
                      }}
                      onDragEnter={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const file = e.dataTransfer.files[0];
                        console.log('File dropped:', file);
                        setFiles(file);
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const file = e.dataTransfer.files[0];
                        console.log('File dropped:', file);
                        setFiles(file);
                      }}>
                      <input
                        onChange={handleFileUpload}
                        className="form-control position-absolute w-100 h-100 top-0 start-0"
                        type="file"
                      />
                      <span className="d-block mb-2">
                        {' '}
                        <FontAwesomeIcon icon={faUpload} />
                      </span>
                      <p className="mb-0">
                        <strong>Click to upload</strong> or Drag and drop file
                      </p>
                      {files && (
                        <div className="mt-3">
                          <p>{files.name}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
            <button className={`btn btn-castleRed btn-width ${((selectedResourceType == 'file' && files == null) || (selectedResourceType == 'url' && url.length == 0) || description.length == 0 || description.length > 100 || url.length > 255 || isWaiting) && 'disabled'}`} onClick={() => { selectedResourceType == 'file' ? handleDocumentUpload() : handleAddResource(selectedResourceType == 'document' ? false : true); }}>
              Add
            </button>
            <button className="btn btn-castleGray btn-width" onClick={() => { setOpenAddResource(false); setDescription(''); setUrl(''); setFiles(null); }}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={openAttachConfirmModal}
        onClose={() => { setOpenAttachConfirmModal(false); }}
        onSave={() => { handleUpdateAssignmentLesson(); setOpenAttachConfirmModal(false); props.setOpenAttachResource(false); }}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          `Are you sure that you want to add the following lesson to your Assignment: "${displayText}" ?`
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <ConfirmationModal
        isOpen={openDetachConfirmModal}
        onClose={() => { setOpenDetachConfirmModal(false); }}
        onSave={() => { handleUpdateAssignmentLesson(); setOpenDetachConfirmModal(false); props.setOpenAttachResource(false); }}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={
          `Are you sure that you want to remove the lesson "${displayText}" from the assignment?`
        }
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
    </>
  );
};

AddNewResource.propTypes = {
  openAttachResource: PropTypes.bool,
  setOpenAttachResource: PropTypes.func,
  assignmentName: PropTypes.string,
  assignmentId: PropTypes.number,
  displayText: PropTypes.string,
  setDisplayText: PropTypes.func,
  validateDisplayText: PropTypes.func,
  castleResourceDetailsHandler: PropTypes.func,
  questionDetails: PropTypes.object,
  setLessonInfo: PropTypes.func,
  setAssignmentDetails: PropTypes.func,
  assignmentDetails: PropTypes.object,
  isLessonAvailable: PropTypes.bool
};

export default AddNewResource;